export default __webpack_public_path__ + "static/media/strong-3-hiit.2151642a.jpg";